import { useState } from 'react';

import { HiDotsVertical } from 'react-icons/hi';
import { toast } from 'react-toastify';

import { Modal } from '~/components';
import { Options } from '~/pages/modules/Professional/MetLibrary/Card/styles';
import { DeleteModalContainer } from '~/pages/modules/Professional/StudentProfile/styles';
import api from '~/services/api';
import { currencyFormatter } from '~/utils/formatter';

import {
  Container,
  Wrapper,
  LineWrapper,
  Label,
  StatusContainer,
  StatusLabel,
  Status,
  FirstSectionContainer,
} from './styles';

type Package = {
  id: number;
  professional_id: number;
  gym_id: number;
  name: string;
  lealtad: string;
  status: string;
  value: number;
  number_of_training_programs: number;
  created_at: string;
  updated_at: string;
};

type CardProps = {
  packageData: Package;
  loadPackages: () => Promise<void>;
  showContent: React.Dispatch<
    React.SetStateAction<'packages' | 'create-or-edit-package'>
  >;
  setIsCreateOrEdit: React.Dispatch<React.SetStateAction<'create' | 'edit'>>;
  setPackageToEditData: React.Dispatch<React.SetStateAction<Package>>;
};

export function Card({
  packageData,
  loadPackages,
  showContent,
  setIsCreateOrEdit,
  setPackageToEditData,
}: CardProps) {
  const [, setLoading] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const loyaltyVariations: { [key: string]: string } = {
    monthly: 'Mensal',
    quarterly: 'Trimestral',
    semiannual: 'Semestral',
    yearly: 'Anual',
  };

  const statusVariations: { [key: string]: string } = {
    active: 'Ativo',
    inactive: 'Inativo',
  };

  const handleDeletePackage = async (packageId: number) => {
    try {
      setLoading(true);

      await api.delete(`/packages/${packageId}`);

      toast.success('Pacote excluído com sucesso!');

      loadPackages();

      setLoading(false);

      setShowDeleteModal(false);
    } catch (error) {
      setLoading(false);
      console.log('error:', error);
      toast.error('Houve um erro ao excluir o pacote');
    }
  };

  const handleNavigateToEditPackagePage = () => {
    setPackageToEditData(packageData);
    setIsCreateOrEdit('edit');
    showContent('create-or-edit-package');
  };

  function DeleteModal() {
    return (
      <Modal isOpen={showDeleteModal} setOpen={setShowDeleteModal}>
        <DeleteModalContainer>
          <h1>Atenção</h1>

          <p>
            Tem certeza que deseja excluir o pacote {` `}
            <strong>{packageData.name}</strong>?
          </p>

          <div>
            <button
              type="button"
              onClick={() => handleDeletePackage(packageData.id)}
            >
              Sim
            </button>
            <button type="button" onClick={() => setShowDeleteModal(false)}>
              Não
            </button>
          </div>
        </DeleteModalContainer>
      </Modal>
    );
  }

  return (
    <Container>
      <DeleteModal />

      <FirstSectionContainer>
        <Wrapper>
          <LineWrapper>
            <Label>Nome: </Label>
            <p>{packageData.name}</p>
          </LineWrapper>
          <LineWrapper>
            <Label>Valor: </Label>
            <p>{currencyFormatter(packageData.value) ?? packageData.value}</p>
          </LineWrapper>
          <LineWrapper>
            <Label>Nº de programas de treino: </Label>
            <p>{packageData.number_of_training_programs}</p>
          </LineWrapper>
          <LineWrapper>
            <Label>Fidelização: </Label>
            <p>
              {loyaltyVariations[packageData.lealtad] ?? packageData.lealtad}
            </p>
          </LineWrapper>
        </Wrapper>

        <Options>
          <HiDotsVertical size={30} color="#000" />

          <div>
            <button onClick={handleNavigateToEditPackagePage} type="button">
              Editar
            </button>

            <div className="divider" />

            <button onClick={() => setShowDeleteModal(true)} type="button">
              Excluir
            </button>
          </div>
        </Options>
      </FirstSectionContainer>
      <Wrapper secondary>
        <StatusContainer status={statusVariations[packageData.status]}>
          <StatusLabel>
            <strong>Status:&nbsp;</strong>
            {statusVariations[packageData.status] ?? packageData.status}
          </StatusLabel>
          <Status />
        </StatusContainer>
      </Wrapper>
    </Container>
  );
}
